import { toast } from "react-toastify";
import { GeneralToast } from "../components/Toast/Toast";

export const showToast = ({
  type,
  toastId,
  content,
  loading = false,
  autoClose = true,
}) => {
  toast(GeneralToast, {
    data: {
      content: content,
      loading,
      type,
    },
    toastId: toastId,
    className:
      "flex items-center w-full z-50 max-w-xs p-4 mb-4 text-gray-500 bg-white rounded-lg shadow dark:text-gray-400 dark:bg-gray-800",
    autoClose: loading ? false : autoClose,
    closeButton: false,
    hideProgressBar: loading,
  });
};

export const hideToast = (id) => {
  toast.dismiss(id);
};
